<!-- order entry version of this -->
<div
  *ngIf="fieldsGroup"
  [bfx-input]="bfxInput"
  [ngClass]="inputDirective.labelClasses"
  class="interface-control__contacts-input__label"
>
  {{ data.label }}
</div>
<bfx-text-input
  #inputField
  class="interface-control__contacts-input__text_input"
  [inputLabelText]="fieldsGroup ? null : data.label"
  [fieldEndIcon]="'fa icon-account_circle'"
  type="search"
  autocomplete="off"
  [(ngModel)]="data.value"
  [disabled]="disabled || client==null || locked"
  [size]="'sm'"
  [required]="false"
  tabindex="-1"
  (click)="onClick($event)"
></bfx-text-input>
